import {
    browserName,
    isMobile,
    isTablet,
    isBrowser,
    browserVersion,
    osVersion,
    engineVersion,
    osName
} from 'react-device-detect';


const SESSION_HELPER = {
    getUserAgent() {
        return {
            browserName,
            isMobile,
            isTablet,
            isBrowser,
            browserVersion,
            osVersion,
            engineVersion,
            osName,
            width: window.innerWidth
        }
    },
}

export default SESSION_HELPER
